import { ADVICE_REQUESTS_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/cancelRequest.graphql'
import { CancelRequestMutation, CancelRequestMutationVariables } from '../interfaces'

export const cancelRequest = async (variables: CancelRequestMutationVariables): Promise<CancelRequestMutation> =>
  request<CancelRequestMutation>(ADVICE_REQUESTS_ENDPOINT, query, variables)
